module.exports = __webpack_public_path__ + "img/dia_ausente.5298e939.svg";